<template>
  <div class="flex flex_gap_5">
    <div><i v-if="drug.cool" class="icon icon-snowflake"/></div>
    <div v-if="getDiscountPrices()" class="pointer">
      <button class="btn btn-outline-info btn-xs">
        <i class="icon-fa icon-fa-percent"
           v-tooltip="{
                      show: toolOpen,
                      placement: 'bottom-center',
                      content: getDiscountPrices(true),
                      classes: 'discount_tooltip tooltip_on_modal'
                    }"
        ></i>
      </button>
    </div>
    <div>
      <v-popover :auto-hide="true" popoverClass="tooltip_on_modal">
        <button
          @click="getDrugInfo()"
          class="btn btn-outline-info btn-xs"
        >
          <i class="icon-fa icon-fa-info"></i>
        </button>

        <template slot="popover">
          <template v-if="!drugInfoLoading">
            <div v-if="projectInfo[drug.id] && projectInfo[drug.id][$editNewOrder.site_id]">
              <div class="mb-1" v-html="printDrugInfo(projectInfo[drug.id][$editNewOrder.site_id])"/>
              <template v-if="projectInfo[drug.id][$editNewOrder.site_id].mirror_sources">
                <div class="mirror_source_data flex"
                     v-for="source in projectInfo[drug.id][$editNewOrder.site_id].mirror_sources">
                  <div class="w-50 mr-1" v-if="source.data.image"><img :src="source.data.image" alt=""></div>
                  <div>
                    <p>Данные на проекте: <strong>{{ source.title }}</strong></p>
                    <p>препарат: <a :href="`${source.data.link_share ?? source.data.link}`"
                                    target="_blank">{{ source.data.title }}</a></p>
                    <p v-if="source.data.manufacturer">производитель:
                      <strong>{{ source.data.manufacturer }}</strong>
                    </p>
                    <p v-if="source.data.country">страна: <strong>{{ source.data.country }}</strong></p>
                    <p v-if="source.data.block_reason"><strong>препарат НЕ отображается
                      ({{ source.data.block_reason }})</strong></p>
                    <p v-if="source.data.price">цена: <strong>{{ source.data.price }}</strong></p>
                  </div>
                </div>
              </template>
            </div>
            <div v-else>
              Нет данных
            </div>
          </template>
          <template v-else>
            Загрузка ....
          </template>
          <button v-close-popover class="btn btn-theme btn-sm">
            Закрыть
          </button>
        </template>
      </v-popover>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['drug'],
  data() {
    return {
      projectInfo: {},
      toolOpen: false,
      drugInfoLoading: false,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  methods: {
    printDrugInfo(data) {
      if (data.error) {
        return '<p class="color-red">' + data.error + '</p>'
      }
      let text = `<p>Препарат <a href="${data.link_share ?? data.link}" target="_blank">${data.title}</a></p>`
      if (data.image_full) {
        text += `<div><img src="${data.image_full}" alt=""></div>`;
      }
      if (data.manufacturer) {
        text += `<p>производитель: <strong>${data.manufacturer}</strong></p>`;
      }
      if (data.country) {
        text += `<p>страна: <strong>${data.country}</strong></p>`;
      }
      return text
    },
    async getDrugInfo() {
      if (this.projectInfo[this.drug.id] && this.projectInfo[this.drug.id][this.$editNewOrder.site_id]) return
      this.drugInfoLoading = true

      const {data} = await api.post('/new/drugs/infoType', {
        types: ['projectInfo', 'siteDetails'],
        drug_id: this.drug.id,
        project_id: this.$editNewOrder.site_id
      })

      if (!this.projectInfo[this.drug.id]) {
        this.projectInfo[this.drug.id] = {};
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = {};
      }
      if (data.success) {
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = data
      } else {
        this.projectInfo[this.drug.id][this.$editNewOrder.site_id] = false
      }
      this.drugInfoLoading = false
    },
    getDiscountPrices(print = false) {
      console.log(this.drug);
      let prices = 0
      let text = ''
      if (!this.drug.prices) {
        return text
      }
      // console.log(this.drug.prices, this.$editNewOrder.site_id, this.drug.prices.filter((p) => +p.site_id === +this.$editNewOrder.site_id && p.is_active));
      this.drug.prices.forEach(p => {
        if (+p.site_id === +this.$editNewOrder.site_id) {
          if (+p.qty === 1 && !p.is_active) return;
          const pieces = +this.drug.pack_set === 1 ? 'шт' : 'компл';
          text += `<p>от ${p.qty} ${pieces}. цена <strong>${p.price * this.drug.pack_set}</strong> руб.</p>`;
          ++prices
        }
      })
      if (!print) return prices > 1
      return text
    },
  }
}

</script>

<style scoped>
.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5bbfde;
  margin: -3px 4px;
}
</style>
